/* QWERTY keyboard. Letter keys carry their best feedback color. The
   utility row (Enter, arrows, Backspace) lives below the letter rows so
   the letters keep clean QWERTY alignment. */

import {
  backspace,
  keyboardMarks,
  moveCursor,
  status,
  submit,
  typeLetter,
} from "../game/state";

const ROWS = ["qwertyuiop", "asdfghjkl", "zxcvbnm"];

export function Keyboard() {
  const marks = keyboardMarks.value;
  const playing = status.value === "playing";

  const renderLetter = (ch: string) => {
    const m = marks.get(ch);
    const cls = ["key", "key--letter", m ? `key--${m}` : ""].filter(Boolean).join(" ");
    return (
      <button
        key={ch}
        type="button"
        class={cls}
        onClick={() => typeLetter(ch)}
        disabled={!playing}
        aria-label={`Letter ${ch.toUpperCase()}`}
        tabIndex={-1}
      >
        {ch.toUpperCase()}
      </button>
    );
  };

  return (
    <div class="keyboard" aria-label="Keyboard">
      {ROWS.map((row) => (
        <div class="keyboard__row" key={row}>
          {row.split("").map(renderLetter)}
        </div>
      ))}
      <div class="keyboard__row">
        <button
          type="button"
          class="key key--util"
          onClick={() => submit()}
          disabled={!playing}
          aria-label="Enter"
          tabIndex={-1}
        >
          Enter
        </button>
        <button
          type="button"
          class="key key--util"
          onClick={() => moveCursor(-1)}
          disabled={!playing}
          aria-label="Cursor left"
          tabIndex={-1}
        >
          ←
        </button>
        <button
          type="button"
          class="key key--util"
          onClick={() => moveCursor(1)}
          disabled={!playing}
          aria-label="Cursor right"
          tabIndex={-1}
        >
          →
        </button>
        <button
          type="button"
          class="key key--util"
          onClick={() => backspace()}
          disabled={!playing}
          aria-label="Backspace"
          tabIndex={-1}
        >
          ⌫
        </button>
      </div>
    </div>
  );
}
